



























import Vue from 'vue'
import FormField from '@/components/app/AppFormField.vue'
export default Vue.extend({
  name: "SystemPage",
  components: {
    FormField
  },
  props: {
    id: {
      type: String
    }
  },

  data() {
    return {
      camera: null as any,
      system: null as any,
      changes: {
      }
    }
  },

  computed: {
    cameraSchema():FormField[] {
      let schema:FormField[] = this.$schema.toArray(this.$store.state.schemas['cameras_cameras'])
      schema = schema.map(field => {
        if (field.fieldTag === "select" && typeof field.options === "string") {
          return Object.assign(field, {options: this.camera.settingsOptions[field.key]})
        } else {
          return field
        }
      })
      return schema
    },
    systemSchema():any {
      return this.$store.state.schemas.cameras
    }
  },

  methods: {
    async getCamera(id) {
      const snapshot = await this.$db.collection('cameras').doc(id).collection('cameras').get()
      if (snapshot.size) {
        let camera = null as any
        snapshot.forEach(doc => {
          camera = {_id: doc.id, ...doc.data()}
          this.$set(this.changes, doc.id, {} as any) 
          return
        })
        this.camera = camera
      }
    },
    async getSystem() {
      const system = await this.$db.collection('cameras').doc(this.id).get()
      if (system.exists) {
        this.system = {...system.data(), _id: system.id}
        this.getCamera(this.id)
      }
    },
    cameraValueChanged(id, key, newValue) {
      const oldValue = this.camera[key]
      if (oldValue !== newValue) {
        this.$set(this.changes[id], key, {old: oldValue, new: newValue})
      } else {
        delete this.changes[id][key]
      }
    },
    async saveCamera(id) {
      try {
        const response = await this.$api.update(`cameras/${this.id}/cameras`, id, this.changes[id])
        this.getSystem()
        this.changes[id] = {}
      } catch (err) {
        window.console.error(err)
      }
    }
  },

  created() {
    this.getSystem()
  }
})
